import { isLoggedInUser } from '../../../../../../../utils/isLoggedInUser';
import { getCurrentDateUnix } from '../../../../../../../utils/timeUtil';
import { REQUEST_TO_ORDER_AUDIENCE, PACKAGE_ID_TO_TYPE } from '../../constants';

export const isRequestToOrderGig = ({ instantOrderSettings, packageId }) => {
    const settings = instantOrderSettings && instantOrderSettings[0];
    const packageType = PACKAGE_ID_TO_TYPE[packageId];

    if (!settings || !packageType) {
        return false;
    }

    const { packages, unavailabilityHours } = settings;
    const currentDateUnix = getCurrentDateUnix();

    const dateMatches = unavailabilityHours.some(
        ({ from, to }) => currentDateUnix > from && currentDateUnix < to
    );

    return dateMatches && packages.includes(packageType);
};

export const shouldShowRequestToOrderBtn = ({ instantOrderSettings, packageId }) => {
    if (!isRequestToOrderGig({ instantOrderSettings, packageId })) {
        return false;
    }

    const { audience, ftbOfSeller } = instantOrderSettings[0];
    const availableForTheFirstTimeBuyersOnly = audience === REQUEST_TO_ORDER_AUDIENCE.AUDIENCE_FIRST_TIME_BUYERS;

    if (!isLoggedInUser() && availableForTheFirstTimeBuyersOnly) {
        return false;
    }

    if (availableForTheFirstTimeBuyersOnly) {
        return ftbOfSeller;
    }

    return true;
};
